import { MAIN_BOARD, validateBoardSlug } from '../shared/boards';

export type BoardRoute = { kind:'game'|'admin'; slug:string; apiPrefix:string; home:string } | {kind:'root';home:'/'} | {kind:'invalid'};
/** A board is fixed for the lifetime of this document. Switching boards reloads all draft/retry state. */
export function resolveBoardRoute(pathname:string):BoardRoute {
  if(pathname==='/main'||pathname==='/main/')return {kind:'game',slug:MAIN_BOARD,apiPrefix:'/api',home:'/main'};
  if(pathname==='/admin'||pathname==='/admin/')return {kind:'admin',slug:MAIN_BOARD,apiPrefix:'/api',home:'/'};
  if(pathname==='/')return {kind:'root',home:'/'};
  const match=/^\/([a-z0-9-]+)\/?$/.exec(pathname);
  if(!match)return {kind:'invalid'};
  try {const slug=validateBoardSlug(match[1]);return {kind:'game',slug,apiPrefix:`/api/boards/${slug}`,home:`/${slug}`};}catch{return {kind:'invalid'};}
}
export function resolveSelectedBoardRoute(selection:unknown):BoardRoute {
  if(!selection||typeof selection!=='object'||!('boardSlug' in selection)||typeof selection.boardSlug!=='string')throw new Error('The main board address is unavailable.');
  const slug=selection.boardSlug===MAIN_BOARD?MAIN_BOARD:validateBoardSlug(selection.boardSlug);
  const route=resolveBoardRoute(`/${slug}`);
  if(route.kind!=='game')throw new Error('The main board address is unavailable.');
  return route;
}
export let currentBoardRoute=resolveBoardRoute(typeof window==='undefined'?'/main':window.location.pathname);
let rootResolution:Promise<BoardRoute>|undefined;
/** Resolve before mounting gameplay; never retarget requests or drafts in an open tab. */
export function initializeBoardRoute(fetcher:typeof fetch=fetch):Promise<BoardRoute> {
  if(currentBoardRoute.kind!=='root')return Promise.resolve(currentBoardRoute);
  return rootResolution??=fetcher('/api/root-board',{credentials:'same-origin',cache:'no-store'})
    .then(async response=>{
      if(!response.ok)throw new Error('The main board could not be loaded.');
      const route=resolveSelectedBoardRoute(await response.json());
      currentBoardRoute=route;
      return route;
    }).catch(error=>{rootResolution=undefined;throw error;});
}
export function boardApiUrl(url:string, route:BoardRoute=currentBoardRoute):string {
  if(!url.startsWith('/api/')||url.startsWith('/api/admin/'))return url;
  if(route.kind!=='game'&&route.kind!=='admin')throw new Error('This board address is unavailable.');
  if(url.startsWith('/api/boards/')) {
    if(!url.startsWith(`${route.apiPrefix}/`))throw new Error('This request belongs to another board.');
    return url;
  }
  return `${route.apiPrefix}${url.slice(4)}`;
}
export function isCurrentBoardImage(url:string,route:BoardRoute=currentBoardRoute):boolean {
  if(route.kind!=='game'&&route.kind!=='admin')return false;
  return url.startsWith(`${route.apiPrefix}/assets/`) && /^[a-zA-Z0-9_-]+\/image$/.test(url.slice(`${route.apiPrefix}/assets/`.length));
}
